import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormInputModule } from '../../shared/form-input/form-input.module';
import { UXModule } from '../../shared/ux/ux.module';
import { LoginComponent } from './login.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, UXModule, FormInputModule],
  declarations: [LoginComponent],
  exports: [LoginComponent],
})
export class LoginModule {}
